// extracted by mini-css-extract-plugin
export default {"card_back_image":"choose-cards_card_back_image__zrF6f","cards_container":"choose-cards_cards_container__oa86S"};